import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b22361a")

_pushScopeId("data-v-4b22361a")
const _hoisted_1 = { class: "card content-card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Deinstalacija je završena", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Hvala vam što ste koristili e-Dnevnik Plus. ")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "bye" }, [
  /*#__PURE__*/_createVNode("div", { class: "messageSent" }, "Poslano!"),
  /*#__PURE__*/_createVNode("form", {
    action: "https://script.google.com/macros/s/AKfycbw5Fs3Y-Ht3Cs3PMdQhpUW_-Xd_poar4w5C3ae1SmNnfTIUKbwm/exec",
    method: "POST"
  }, [
    /*#__PURE__*/_createVNode("div", { style: {"padding-top":"30px"} }, [
      /*#__PURE__*/_createVNode("label", { class: "radio" }, [
        /*#__PURE__*/_createVNode("input", {
          type: "radio",
          name: "Option: ",
          value: "PERFECT"
        }),
        /*#__PURE__*/_createVNode("span", null, "Školovanje je završeno i više mi ne treba.")
      ]),
      /*#__PURE__*/_createVNode("label", { class: "radio" }, [
        /*#__PURE__*/_createVNode("input", {
          type: "radio",
          name: "Option: ",
          value: "NOT GOOD"
        }),
        /*#__PURE__*/_createVNode("span", null, "Ne sviđa mi se, očekivao sam više.")
      ]),
      /*#__PURE__*/_createVNode("label", { class: "radio" }, [
        /*#__PURE__*/_createVNode("input", {
          type: "radio",
          name: "Option: ",
          value: "ERROR"
        }),
        /*#__PURE__*/_createVNode("span", null, "Ne radi ispravno.")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "msgNsubmit" }, [
      /*#__PURE__*/_createVNode("textarea", {
        class: "card message",
        name: "Comment: ",
        type: "text"
      }),
      /*#__PURE__*/_createVNode("a", {
        class: "submit",
        type: "submit"
      }, "Pošalji")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
})